<form [formGroup]="NoteFormGroup">
  <div class="modal-header">
    <h3 class="mb-0">{{ titleAction }} note</h3>
    <button
      type="button"
      class="btn-close"
      aria-label="Close"
      (click)="close()"
    ></button>
  </div>

  <div class="modal-body">
    @if (!disableTitle) {
      <div class="form-group">
        <label class="form-label">Title</label>
        @if (!titleOptions || titleOptions.length === 0) {
          <input type="text" class="form-control" formControlName="title" />
        }
        @if (titleOptions && titleOptions.length > 0) {
          <select class="form-select" formControlName="title">
            <option [value]="''" selected disabled>Pick one...</option>
            @for (title of titleOptions; track title) {
              <option [value]="title">
                {{ title }}
              </option>
            }
          </select>
        }
      </div>
    }

    <div class="form-group">
      <label class="form-label">Note</label>
      <textarea class="form-control" formControlName="note" rows="6"></textarea>
    </div>

    @if (allowFileUpload) {
      <div class="form-group">
        <app-file-upload-file-display
          [layout]="'vertical'"
          [Files]="Files"
          (FileEvent)="addFile($event)"
        ></app-file-upload-file-display>
      </div>
    }

    @if (isAdminUser()) {
      <div class="check-group mt-0">
        <input
          type="checkbox"
          class="form-check-input"
          formControlName="isSensitive"
          id="note-internal"
        />
        <label class="form-check-label mt-0" for="note-internal">
          Internal note?
        </label>
      </div>
    }
  </div>

  <div class="modal-footer">
    <div class="action-row justify-end w-100">
      @if (!canEditNote) {
        <button type="button" class="btn btn-primary" (click)="close()">
          Close
        </button>
      }

      @if (canEditNote) {
        <button type="button" class="btn btn-ghost" (click)="close()">
          Cancel
        </button>
        <button type="button" class="btn btn-primary" (click)="saveNote()">
          Save
        </button>
      }
    </div>
  </div>
</form>
